import { updateFinding } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    finding?: any;
    savedFindingID?: any;
    source?: any;

}

export async function processFinding ({finding,savedFindingID,source}: Props) {
    await updateFinding(finding,savedFindingID,source);
}

